import { arrayOf, bool, func, object } from 'prop-types';
import React from 'react';

import { calendarJackpot } from 'calendar/proptypes';
import Announce from 'shared/components/Announce';
import ComponentLoadingSection from 'shared/components/ComponentLoadingSection';
import ErrorInfo from 'shared/components/ErrorInfo';
import { getText } from 'shared/utils/Text';

import Heading from './Heading';
import JackpotItem from './JackpotItem';

const Jackpots = ({ jackpots, hasJackpots, error, onItemClick }) => (
  <ComponentLoadingSection loading={!hasJackpots && !error}>
    <Announce />
    <Heading
      title={getText('calendar-jackpot-title')}
      subTitle={getText(
        error
          ? null
          : jackpots.length === 0
          ? 'calendar-jackpot-empty-subtitle'
          : 'calendar-jackpot-subtitle',
      )}
      isJackpot
    />

    {jackpots.length > 0 && (
      <ul>
        {jackpots.map((jackpot, idx) => (
          <JackpotItem key={idx} jackpot={jackpot} onClick={onItemClick} />
        ))}
      </ul>
    )}
    {error && <ErrorInfo error={error} />}
  </ComponentLoadingSection>
);

Jackpots.propTypes = {
  jackpots: arrayOf(calendarJackpot).isRequired,
  hasJackpots: bool,
  error: object,
  onItemClick: func.isRequired,
};

export default Jackpots;
